import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    isLoggedIn: false,
    userIp: localStorage.getItem('userIp') || null, // 初始化时从localStorage获取
    userId: null,
    userLocation: JSON.parse(localStorage.getItem('userLocation')) || null, // 初始化时从localStorage获取用户位置
  }),

  getters: {
    // 获取用户信息
    getUserInfo: (state) => state.user,
    // 获取登录状态
    getLoginStatus: (state) => state.isLoggedIn,
    // 获取用户IP
    getUserIp: (state) => state.userIp || localStorage.getItem('userIp'), // 优先从state获取，否则从localStorage获取
    // 获取用户ID
    getUserId: (state) => state.userId,
    // 获取用户位置信息
    getUserLocation: (state) => state.userLocation || JSON.parse(localStorage.getItem('userLocation') || 'null'),
  },

  actions: {
    // 设置用户信息
    setUser(userInfo) {
      this.user = userInfo;
      this.isLoggedIn = true;
      if (userInfo.userId) {
        this.userId = userInfo.userId;
      }
      // 可以选择将用户信息保存到 localStorage
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },

    // 设置用户IP
    setUserIp(ip) {
      console.log('设置用户IP:', ip);
      this.userIp = ip;
      localStorage.setItem('userIp', ip);
      // 打印存储状态
      console.log('IP存储完成：', {
        storeIp: this.userIp,
        localStorageIp: localStorage.getItem('userIp')
      });
    },

    // 设置用户ID
    setUserId(id) {
      this.userId = id;
      localStorage.setItem('userId', id.toString());
    },

    // 设置用户位置信息
    setUserLocation(locationData) {
      console.log('设置用户位置信息:', locationData);
      this.userLocation = locationData;
      localStorage.setItem('userLocation', JSON.stringify(locationData));
      console.log('位置信息存储完成');
    },

    // 清除用户信息
    clearUser() {
      this.user = null;
      this.isLoggedIn = false;
      this.userIp = null;
      this.userId = null;
      this.userLocation = null;
      // 清除 localStorage 中的用户信息
      localStorage.removeItem('userInfo');
      localStorage.removeItem('userIp');
      localStorage.removeItem('userId');
      localStorage.removeItem('userLocation');
    },

    // 初始化用户状态（从 localStorage 恢复）
    initUserState() {
      console.log('初始化用户状态...');
      const savedUserInfo = localStorage.getItem('userInfo');
      const savedUserIp = localStorage.getItem('userIp');
      const savedUserId = localStorage.getItem('userId');
      const savedUserLocation = localStorage.getItem('userLocation');

      if (savedUserInfo) {
        try {
          this.user = JSON.parse(savedUserInfo);
          this.isLoggedIn = true;
        } catch (error) {
          console.error('解析用户信息失败:', error);
          this.clearUser();
        }
      }

      if (savedUserIp) {
        console.log('从localStorage恢复用户IP:', savedUserIp);
        this.userIp = savedUserIp;
      }

      if (savedUserId) {
        this.userId = parseInt(savedUserId);
      }

      if (savedUserLocation) {
        try {
          console.log('从localStorage恢复用户位置信息');
          this.userLocation = JSON.parse(savedUserLocation);
        } catch (error) {
          console.error('解析用户位置信息失败:', error);
          this.userLocation = null;
          localStorage.removeItem('userLocation');
        }
      }

      // 打印当前状态
      console.log('用户状态初始化完成：', {
        userIp: this.userIp,
        userId: this.userId,
        isLoggedIn: this.isLoggedIn,
        hasLocationInfo: !!this.userLocation
      });
    }
  }
}); 